import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable()
export class AuthRateLimitInterceptor implements HttpInterceptor {
    
    private showingAlert = false;

    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                console.log('AuthRateLimitInterceptor - Error interceptado:', error);
                console.log('Interceptor - Status:', error.status);
                console.log('Interceptor - Error body:', error.error);
                
                // Solo procesar errores 429
                if (error.status === 429) {
                    // Extraer datos del backend
                    const errorData = error.error || {};
                    const message = errorData.Message || 'Demasiados intentos. Por favor, intente nuevamente más tarde.';
                    const retrySeconds = errorData.RetryAfterSeconds || 60;
                    const retryMinutes = errorData.RetryAfterMinutes || Math.ceil(retrySeconds / 60);

                    console.log('Rate Limit - Mensaje:', message);
                    console.log('Rate Limit - Segundos:', retrySeconds);
                    console.log('Rate Limit - Minutos:', retryMinutes);

                    // Mostrar alerta solo si no hay una activa
                    if (!this.showingAlert) {
                        this.showingAlert = true;
                        
                        Swal.fire({
                            icon: 'warning',
                            title: '¡Demasiados intentos!',
                            text: message,
                            confirmButtonText: 'Entendido',
                            allowOutsideClick: false
                        }).then(() => {
                            this.showingAlert = false;
                        });
                    }

                    // Retornar error simplificado
                    return throwError(() => ({
                        code: 429,
                        message: message,
                        retryAfterSeconds: retrySeconds,
                        retryAfterMinutes: retryMinutes
                    }));
                }

                // Propagar cualquier otro error sin modificar
                return throwError(() => error);
            })
        );
    }
}
